import { defineStore } from 'pinia'
import {services, getHeader, getKycHeader } from '@/assets/js/config.js'
import axios from 'axios'
import { useInitialProposalStore } from '@/stores/initialProposalStore'

export const useKycStore = defineStore('kycStore', {
  state:() => ({
    kyc_loading: false,
    kyc_user: null,
    kyc_error: null,
    viewable_customer_ids: [],
    viewable_customer_nrics: [],
		customer_variable_expenses: []
  }),
  actions : {
    saveToken(access_token, refresh_token){
        var kyc_token = {
            access_token: access_token,
            refresh_token: refresh_token
        }
        window.localStorage.setItem('kyc_token', JSON.stringify(kyc_token))
    },
    saveUser(user){
        var kyc_user = {
            id: user.id,
            role_id: user.role ? user.role.role_id : user.role_id,
            name: user.name,
            email: user.email,
        }
        window.localStorage.setItem('kyc_user', JSON.stringify(kyc_user))
        this.kyc_user = kyc_user
    },
    clearAuth(){
        this.kyc_user = null
        // localStorage.clear()
    },
    async kycLogin(email, password){  
        const form_data = {
            email : email,
            password : password,
        }

        try {
            this.kyc_error = null
            this.kyc_loading = true
            const res = await axios.post(services.kyc_api + '/api/kyc_login', form_data, { headers: getHeader() })
            this.saveToken(res.data.access_token, res.data.refresh_token)
            this.saveUser(res.data.user)

            this.kyc_loading = false
        }
        catch (e) {
            this.kyc_loading = false
            this.kyc_error = e
            this.clearAuth()
        }
    },
    async fetchUserInfo(token = null){
        if(token){
            window.localStorage.setItem('kyc_token', JSON.stringify({
                access_token: token,
            }));
        }

        if(localStorage.getItem("kyc_token") === null){
            return;
        }
        
        try {
            const res = await axios.get(services.kyc_api + '/setup/user.info', { headers: getKycHeader() })
            this.saveUser(res.data)
        }catch(e) {
            // this.clearAuth()
            console.log(e)
        }
    },
    async logout(){
        this.clearAuth()
    },
		async getCustomerVariableExpenses(customer_id) {
			const data = {
				"external_customer_id": customer_id,
				"external_application_name": 'IM2U V2',
			};
			try {
				this.customer_variable_expenses = [];
				const res = await axios.post(services.kyc_api + '/customers/customer_form.get_latest_customer_form', data, { headers: getKycHeader() });
				if(!_gHlp.isEmpty(res.data)){
					this.customer_variable_expenses = res.data

					let ttl_question = _gHlp.getValue(res.data,'data.0.total_customer_questions',0);
					let ttl_answer = _gHlp.getValue(res.data,'data.0.total_customer_answered_questions',0);
					if(ttl_question > 0){
						if(ttl_question == ttl_answer){
							useInitialProposalStore().setKycLinkStatus('text-success'); //user answera all
						}else{
							useInitialProposalStore().setKycLinkStatus('text-danger'); //user not answera all
						}
					}else{
						useInitialProposalStore().setKycLinkStatus('text-info');
					}
				}else{
					useInitialProposalStore().setKycLinkStatus('text-info'); //agent already send link
				}
				return this.customer_variable_expenses;
			}catch(e) {
				// this.clearAuth()
				_gNotif.errorFunction(e)
				useInitialProposalStore().setKycLinkStatus('text-seccess');
				return [];
			}
				
		},
  }
})